// extracted by mini-css-extract-plugin
module.exports = {"noborder":"profile_noborder__ktcQd","withBorder":"profile_withBorder__2wwAQ","avatarImg":"profile_avatarImg__3qNzH","formHint":"profile_formHint__u8Qh0"};